import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../../constants/index";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import Dynamic_PR_table from "../../../../../components/Dynamic_PR_table";
import { useNavigate } from "react-router-dom";

const EmployeeTaxRegime = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Tax Regime"));
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [taxRegime, setTaxRegime] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    EmpName: { text: "Name", visible: true },
    FYFromDate: { text: "From Date", align: "center", visible: true },
    FYToDate: { text: "To Date", align: "center", visible: true },
    Regime: { text: "Regime", visible: true },
    CityType: { text: "City Type", visible: true },
  };

  const fetchTaxRegime = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/finance/employee-tax-regime`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        let TaxData = response?.data?.data;
        TaxData = TaxData?.sort((a, b) => a.ID - b.ID);
        setTaxRegime(TaxData);
      } else {
        console.error(
          "Failed to fetch Tax Regime. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Tax Regime:", error);
    }
  };

  useEffect(() => {
    fetchTaxRegime();
  }, []);

  const handleAddForm = () => {
    navigate(`/employee-tax-regime/add`);
  };

  const handleEdit = (id) => {
    navigate(`/employee-tax-regime/edit/${id.ID}`)
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={taxRegime}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon1={true}
              isSrNoRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isActionRequired={true}
              searchTerm={searchTerm}
              isAddNewBtnRequired={true}
              handleAddNew={handleAddForm}
              setSearchTerm={setSearchTerm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square"></i>,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeTaxRegime;
